import { SvgIcon } from 'ui/icons';

export const Devices = () => (
  <SvgIcon height="128" width="128" viewBox="0 0 128 128">
    <g clipPath="url(#clip0)">
      <path
        d="M115.84 71.808C115.84 64.1676 114.129 56.6242 110.834 49.7309C107.539 42.8377 102.742 36.7693 96.797 31.9706C90.8515 27.172 83.9074 23.7649 76.4739 21.999C69.0403 20.2332 61.3058 20.1534 53.8374 21.7655C46.3691 23.3776 39.3561 26.6407 33.3129 31.3156C27.2696 35.9905 22.3492 41.9586 18.9125 48.7824C15.4758 55.6063 13.6098 63.1127 13.4514 70.7515C13.2931 78.3902 14.8463 85.9676 17.9972 92.928H111.284C114.293 86.2941 115.847 79.0926 115.84 71.808Z"
        fill="#F5F4F4"
      />
      <path
        d="M14.0801 92.9282H113.92"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.32031 92.9282H11.5203"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M116.48 92.9282H119.68"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.91 104.96C95.91 106.24 81.83 107.392 64.3324 107.392C46.8348 107.392 32.7676 106.304 32.7676 104.96C32.7676 103.616 46.8476 102.528 64.3324 102.528C81.8172 102.528 95.91 103.68 95.91 104.96Z"
        fill="#F5F4F4"
      />
      <circle cx="47" cy="81" r="23.5" fill="white" stroke="#6A266D" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.667 69.6401C31.667 69.0879 32.1147 68.6401 32.667 68.6401H61.3337C61.8859 68.6401 62.3337 69.0879 62.3337 69.6401V91.9601C62.3337 92.5124 61.8859 92.9601 61.3337 92.9601H32.667C32.1147 92.9601 31.667 92.5124 31.667 91.9601V69.6401Z"
        fill="#E6FBFF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.667 76.04C39.667 75.4878 40.1147 75.04 40.667 75.04H53.3337C53.8859 75.04 54.3337 75.4878 54.3337 76.04V83C54.3337 83.5523 53.8859 84 53.3337 84H40.667C40.1147 84 39.667 83.5523 39.667 83V76.04Z"
        fill="#FDF5FF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.667 76.9604L45.667 79.9045C46.4921 80.3618 47.5086 80.3618 48.3337 79.9045L54.3337 76.9604"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.1846 98.0804C44.2895 96.5766 44.9199 94.7991 45.0006 92.9604"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M50.9998 98.0002L49 92.9604Z" fill="#B56DC6" />
      <path d="M50.9998 98.0002L49 92.9604H45L43 98.0002H50.9998Z" fill="#B56DC6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.9998 98.0002L49 92.9604Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.9998 98.0002L49 92.9604H45L43 98.0002H50.9998Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M41 98.0801H53" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path fillRule="evenodd" clipRule="evenodd" d="M32 90H62Z" fill="#B56DC6" />
      <path d="M32 90H62V92H32V90Z" fill="#B56DC6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 90H62Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M32 90H62V92H32V90Z" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M32.5 92H61.5" stroke="#B56DC6" />
      <circle cx="93" cy="81" r="15.5" fill="white" stroke="#6A266D" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.5 83.5V90.5C94.5 91.6046 93.6046 92.5 92.5 92.5H85.5C84.3954 92.5 83.5 91.6046 83.5 90.5V75.5C83.5 74.3954 84.3954 73.5 85.5 73.5H89.5"
        fill="#6A266D"
      />
      <path
        d="M94.5 83.5V90.5C94.5 91.6046 93.6046 92.5 92.5 92.5H85.5C84.3954 92.5 83.5 91.6046 83.5 90.5V75.5C83.5 74.3954 84.3954 73.5 85.5 73.5H89.5H94.5V83.5Z"
        fill="#6A266D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.5 83.5V90.5C94.5 91.6046 93.6046 92.5 92.5 92.5H85.5C84.3954 92.5 83.5 91.6046 83.5 90.5V75.5C83.5 74.3954 84.3954 73.5 85.5 73.5H89.5"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M94.5 83.5V90.5C94.5 91.6046 93.6046 92.5 92.5 92.5H85.5C84.3954 92.5 83.5 91.6046 83.5 90.5V75.5C83.5 74.3954 84.3954 73.5 85.5 73.5H89.5H94.5V83.5Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M89.5 77.5H83.5V88.5H94.5V77.5H89.5Z"
        fill="#E6FBFF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M94.5 88.5H83.5" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M87.5 75.5H89.5" stroke="#B56DC6" strokeLinecap="round" strokeLinejoin="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.5 77C106.5 77.8284 105.828 78.5 105 78.5H99.5L96.5 81.5V78.5H93C92.1716 78.5 91.5 77.8284 91.5 77V71C91.5 70.1716 92.1716 69.5 93 69.5H105C105.828 69.5 106.5 70.1716 106.5 71V77Z"
        fill="#FDF5FF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M99.25 73.5C99.1119 73.5 99 73.6119 99 73.75C99 73.8881 99.1119 74 99.25 74C99.3881 74 99.5 73.8881 99.5 73.75C99.5 73.6119 99.3881 73.5 99.25 73.5"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M102.75 73.5C102.612 73.5 102.5 73.6119 102.5 73.75C102.5 73.8881 102.612 74 102.75 74C102.888 74 103 73.8881 103 73.75C103 73.6119 102.888 73.5 102.75 73.5"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.75 73.5C95.6119 73.5 95.5 73.6119 95.5 73.75C95.5 73.8881 95.6119 74 95.75 74C95.8881 74 96 73.8881 96 73.75C96 73.6119 95.8881 73.5 95.75 73.5"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M89 90.25V90.25C89.1381 90.25 89.25 90.3619 89.25 90.5V90.5C89.25 90.6381 89.1381 90.75 89 90.75V90.75C88.8619 90.75 88.75 90.6381 88.75 90.5V90.5C88.75 90.3619 88.8619 90.25 89 90.25"
        stroke="#B56DC6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="70" cy="43" r="15.5" fill="white" stroke="#6A266D" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.5 33.5C63.5 32.3954 64.3954 31.5 65.5 31.5H74.5C75.6046 31.5 76.5 32.3954 76.5 33.5V52.5C76.5 53.6046 75.6046 54.5 74.5 54.5H65.5C64.3954 54.5 63.5 53.6046 63.5 52.5V33.5Z"
        fill="#6A266D"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M76.5 50.5H63.5Z" fill="#E6FBFF" />
      <path d="M76.5 50.5H63.5V35.5H76.5V50.5Z" fill="#E6FBFF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.5 50.5H63.5Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.5 50.5H63.5V35.5H76.5V50.5Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.5 40.5C65.5 39.9477 65.9477 39.5 66.5 39.5H73.5C74.0523 39.5 74.5 39.9477 74.5 40.5V44.5C74.5 45.0523 74.0523 45.5 73.5 45.5H66.5C65.9477 45.5 65.5 45.0523 65.5 44.5V40.5Z"
        fill="#FDF5FF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M65.5 41.5H74.5Z" fill="#B56DC6" />
      <path d="M65.5 41.5H74.5" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path fillRule="evenodd" clipRule="evenodd" d="M70.5 43.5H72.5Z" fill="#B56DC6" />
      <path d="M70.5 43.5H72.5" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70 52.25C70.1381 52.25 70.25 52.3619 70.25 52.5V52.5C70.25 52.6381 70.1381 52.75 70 52.75V52.75C69.8619 52.75 69.75 52.6381 69.75 52.5V52.5C69.75 52.3619 69.8619 52.25 70 52.25"
        fill="#B56DC6"
      />
      <path
        d="M70 52.25C70.1381 52.25 70.25 52.3619 70.25 52.5V52.5C70.25 52.6381 70.1381 52.75 70 52.75V52.75C69.8619 52.75 69.75 52.6381 69.75 52.5V52.5C69.75 52.3619 69.8619 52.25 70 52.25"
        stroke="#B56DC6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M76.5 35.5H63.5Z" fill="#B56DC6" />
      <path d="M76.5 35.5H63.5" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M68.5 33.5H71.5" stroke="#B56DC6" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="128" height="128" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
